export default __webpack_public_path__ + "static/media/lead-andres.70957393.png";